
import { createRouter, createWebHashHistory } from 'vue-router'
import IndexPage from '../components/index'
import AboutPage from '../components/about'
import BasicPage from '../components/basic'
import OutlinePage from '../components/outline'
import TablePage from '../components/table'
import RichPage from '../components/rich'
import AnnotatePage from '../components/annotate'
import CopyPage from '../components/copy'
import MarkdownPage from '../components/markdown'
import EmbedPage from '../components/embed'
import higlightPage from '../components/extract'
import CommitPage from '../components/commit'
import RelatePage from '../components/relate'
import CommonPage from '../components/common'
import ShortcutPage from '../components/shortcut'
import PricePage from '../components/price'


const routes = [
    {
      path: '/',
      component: IndexPage
    },
    {
        path: '/about',
        component: AboutPage
      },
      {
        path: '/basic',
        component: BasicPage
      },
      {
        path: '/outline',
        component: OutlinePage
      },
      {
        path: '/table',
        component: TablePage
      },
      {
        path: '/rich',
        component: RichPage
      },
      {
        path: '/pdfAnnotator',
        component: AnnotatePage
      },
      {
        path: '/markdown',
        component: MarkdownPage
      },
      {
        path: '/copy',
        component: CopyPage
      },
      {
        path: '/embed',
        component: EmbedPage
      },
      {
        path: '/highlight',
        component: higlightPage
      },
      {
        path: '/commitHighlight',
        component: CommitPage
      },
      {
        path: '/relate',
        component: RelatePage
      },
      {
        path: '/common',
        component: CommonPage
      },
      {
        path: '/shortcut',
        component: ShortcutPage
      },
      {
        path: '/price',
        component: PricePage
      },
  ]


  const router = createRouter({
    history: createWebHashHistory(),
    routes: routes,
  })

  export  default router;